import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchAssurances = createAsyncThunk("assurances/fetchAll", async ({ page = 1, pageSize = 10 } = {}, { rejectWithValue }) => {
  try { const r = await api.get('/Assurance', { params: { page, pageSize } }); return r.data; } // PagedResult
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const createAssurance = createAsyncThunk("assurances/create", async (data, { rejectWithValue }) => {
  try {
    await api.post('/Assurance', data);
    const list = await api.get('/Assurance', { params: { page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  } catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const updateAssurance = createAsyncThunk("assurances/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    await api.patch(`/Assurance/${id}`, data);
    const list = await api.get('/Assurance', { params: { page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const deleteAssurance = createAsyncThunk("assurances/delete", async (id, { rejectWithValue }) => {
  try { await api.delete(`/Assurance/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

const pagedFulfilled = (state, action) => {
  state.loading = false;
  state.items = action.payload.items;
  state.totalCount = action.payload.totalCount;
  state.totalPages = action.payload.totalPages;
  state.currentPage = action.payload.page ?? 1;
  state.success = true;
};

const slice = createSlice({
  name: "assurances",
  initialState: {
    items: [],
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSuccess: (state) => { state.success = false; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssurances.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAssurances.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(fetchAssurances.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(createAssurance.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createAssurance.fulfilled, (state, action) => { pagedFulfilled(state, action); state.currentPage = 1; })
      .addCase(createAssurance.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(updateAssurance.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(updateAssurance.fulfilled, (state, action) => { pagedFulfilled(state, action); state.currentPage = 1; })
      .addCase(updateAssurance.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(deleteAssurance.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(deleteAssurance.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter(i => i.id !== action.payload);
        state.totalCount = Math.max(0, state.totalCount - 1);
        state.success = true;
      })
      .addCase(deleteAssurance.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { resetSuccess, clearError } = slice.actions;
export default slice.reducer;
